import { useEffect, useState } from "react"
import Wrapper from "./GetHelp.styles"
import chat from "../../assets/Shared/GetHelp/chat.svg"
import laptop from "../../assets/Shared/GetHelp/laptop.svg"
import Outline32ERemove from '@mds/mds-icons/icons/svg/outline-32-e-remove.svg';
import CommonEndpoints from "../../Services/CommonEndpoints";
import { useCreateToast } from "../../Hooks/useCreateToast";
import LocalStorage, { Keys } from "../../Storage/LocalStorage";

export const GetHelp = ({ setShowGetHelp, title }) => {

    const [showQueryForm, setShowQueryForm] = useState(!!title);
    const [selectedAsset, setSelectedAsset] = useState(title || "general")
    const [message, setMessage] = useState("")
    const [status, setStatus] = useState("Send")
    const [disable, setDisable] = useState(false)
    const [itSupport] = useState("get IT Support")
    const [general] = useState("general")

    const { createErrorToast } = useCreateToast();

    useEffect(() => {
        const modalElement = window.document.querySelector('.getHelpModal:not(.container)');
        const handleClick = e => {
            if (e.target.classList.contains('getHelpModal')) {
                setShowGetHelp(false);
            }
        };

        if (modalElement) {
            modalElement.addEventListener('click', handleClick);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener('click', handleClick);
            }
        };
    }, [setShowGetHelp]);

    const sendEmail = (e) => {
       if(message.trim().length == 0)
        return
        if(!disable)
        setDisable(true)
        if(selectedAsset === itSupport)
        {
            CommonEndpoints.SendEmailToIT(
            {
                Subject: "Request",
                Body: message
            })
            .then(({ data }) => {
                setStatus("Request sent!")
                setTimeout(() => {
                    setStatus(null)
                }, 2000)
            })
            .catch(e => createErrorToast(e))
            .finally(() => {
                setTimeout(() => {
                    setStatus("Send")
                    setShowGetHelp(false)
                }, 2000)
            })
        }
        else {
        CommonEndpoints.SendEmailToGeneral(LocalStorage.get(Keys.CURRENT_ASSET).assetId,
            {
                Subject: "Query",
                Body: message
            })
            .then(({ data }) => {
                setStatus("Request sent!")
                setTimeout(() => {
                    setStatus(null)
                }, 2000)
            })
            .catch(e => createErrorToast(e))
            .finally(() => {
                setTimeout(() => {
                    setStatus("Send")
                    setShowGetHelp(false)
                }, 2000)
            })
        }
        if(disable)
        setDisable(false)
    }

    return (
        <Wrapper className="">
            <div className="container">
                {
                    showQueryForm
                        ? <div className="queryForm">
                            <h2>
                                {
                                    selectedAsset === general
                                        ? "General inquiry"
                                        : 'Submit a query to ' + selectedAsset
                                }
                            </h2>
                            <img className="close" src={Outline32ERemove} alt="Close" tabIndex="0"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        setShowGetHelp(false);
                                    }
                                }} onClick={e => setShowGetHelp(false)} />
                            <textarea
                                cols="30"
                                rows="10"
                                placeholder="Type your question..."
                                value={message}
                                onChange={e => setMessage(e.target.value)}
                            />
                            <br /><br />
                            <div className="flex space-between">
                                <input className="secondary" type="button" value="Cancel" onClick={e => setShowGetHelp(false)} />
                                <input className="primary" disabled={disable} type="button" value={status} onClick={sendEmail} />
                            </div>
                        </div>
                        : <div className="top">
                            <h1>Get Help</h1>
                            <img className="close" src={Outline32ERemove} alt="Close" tabIndex="1"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        setShowGetHelp(false);
                                    }
                                }} onClick={e => setShowGetHelp(false)} />
                            <div className="inner">
                                <div className="left">
                                    <div className="box" tabIndex="2"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                setSelectedAsset(general);
                                                setShowQueryForm(true);
                                            }
                                        }} onClick={e => {
                                            setSelectedAsset(general)
                                            setShowQueryForm(true)
                                        }}>
                                        <div className="flex gap-10">
                                            <img src={chat} alt="" />
                                            <h2>Submit a general query</h2>
                                        </div>
                                        <p>Here you can submit a general query for a more comprehensive study</p>
                                    </div>
                                    <div className="box" tabIndex="3"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                setSelectedAsset(itSupport);
                                                setShowQueryForm(true);
                                            }
                                        }} onClick={e => {
                                            setSelectedAsset(itSupport)
                                            setShowQueryForm(true)
                                        }}>
                                        <div className="flex gap-10">
                                            <img src={laptop} alt="" />
                                            <h2>Get IT support</h2>
                                        </div>
                                        <p>Here you can get quick support from IT support to solve your issues</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
                <div className="bottom">
                </div>
            </div>
        </Wrapper>
    )
}